module.exports = __webpack_public_path__ + "img/cart-icon.accb27de.svg";